import { getData, post } from 'services/api';

import {
	OrphanedSeatsResponse,
	SeatRemapMapping,
	SeatRemapResponse,
	SeatsSyncPreviewResponse,
	SeatsSyncStatusResponse,
} from './types';

export const getSeatsSyncStatus = (): Promise<SeatsSyncStatusResponse> => getData('/internal/events/seats-sync-status');

// The endpoint previews (dry-run) by default; only apply=true commits.
export const previewEventSeatsChart = (eventId: number): Promise<SeatsSyncPreviewResponse> =>
	post(`/internal/events/${eventId}/sync-seats-chart`, {});

export const syncEventSeatsChart = (eventId: number) =>
	post(`/internal/events/${eventId}/sync-seats-chart?apply=true`, {});

export const getOrphanedSeats = (eventId: number): Promise<OrphanedSeatsResponse> =>
	getData(`/internal/events/${eventId}/orphaned-seats`);

// Same preview-by-default contract as the sync endpoint.
export const remapOrphanedSeats = (
	eventId: number,
	mappings: SeatRemapMapping[],
	apply: boolean
): Promise<SeatRemapResponse> =>
	post(`/internal/events/${eventId}/remap-orphaned-seats${apply ? '?apply=true' : ''}`, { mappings });
